import { useEffect, useState } from 'react'
import Layout from './Layout'
import api from '../services/api'

const PERFIS = {
  admin:     { label:'Administrador', bg:'#FCEBEB', cor:'#791F1F', desc:'Acesso total ao sistema' },
  chefe:     { label:'Chefe de setor', bg:'#EEEDFE', cor:'#534AB7', desc:'Tramita e aprova do seu setor' },
  atendente: { label:'Atendente', bg:'#E6F1FB', cor:'#185FA5', desc:'Visualiza e tramita processos' },
  protocolo: { label:'Protocolo', bg:'#FAEEDA', cor:'#854F0B', desc:'Abre e encaminha processos' },
  servidor:  { label:'Servidor', bg:'#EAF3DE', cor:'#3B6D11', desc:'Apenas portal do servidor' },
}

export default function Usuarios() {
  const [lista, setLista] = useState([])
  const [secretarias, setSecretarias] = useState([])
  const [form, setForm] = useState({ nome:'', email:'', senha:'', perfil:'atendente', setor_id:'', telefone:'', perfil_id:'' })
  const [editando, setEditando] = useState(null)
  const [senhaProvisoria, setSenhaProvisoria] = useState(null)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')
  const [load, setLoad] = useState(false)
  const [abaSolicitacoes, setAbaSolicitacoes] = useState(false)

  const [perfisLista, setPerfisLista] = useState([])

  useEffect(() => {
    carregar(); carregarSecretarias()
    api.get('/perfis').then(r => setPerfisLista(r.data)).catch(() => {})
  }, [])

  async function carregar() {
    try { const r = await api.get('/usuarios'); setLista(r.data) } catch {}
  }

  async function carregarSecretarias() {
    try { const r = await api.get('/secretarias'); setSecretarias(r.data) } catch {}
  }

  const set = (k,v) => setForm(f => ({...f,[k]:v}))

  async function salvar() {
    if (!form.nome || !form.email) { setErro('Nome e e-mail são obrigatórios'); return }
    if (!editando && !form.senha) { setErro('Senha é obrigatória para novo usuário'); return }
    setErro('')
    try {
      if (editando) { await api.put(`/usuarios/${editando}`, form); setSucesso('Usuário atualizado!') }
      else { await api.post('/usuarios', form); setSucesso('Usuário criado!') }
      setForm({ nome:'', email:'', senha:'', perfil:'atendente', setor_id:'', telefone:'' })
      setEditando(null); carregar()
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao salvar') }
  }

  function editar(u) {
    setEditando(u.id)
    setForm({ nome:u.nome, email:u.email, senha:'', perfil:u.perfil, setor_id:u.setor_id||'', telefone:u.telefone||'' })
    window.scrollTo(0,0)
  }

  async function gerarSenhaProvisoria(usuario) {
    setLoad(true)
    try {
      const r = await api.post(`/usuarios/${usuario.id}/senha-provisoria`)
      setSenhaProvisoria({ ...usuario, senha: r.data.senha_provisoria })
      carregar()
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao gerar senha') }
    finally { setLoad(false) }
  }

  async function toggleAtivo(u) {
    try {
      await api.put(`/usuarios/${u.id}`, { ...u, ativo: !u.ativo })
      carregar()
    } catch {}
  }

  const solicitacoes = lista.filter(u => u.solicitou_senha)

  return (
    <Layout>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:18, fontWeight:500, margin:0 }}>Usuários do sistema</h1>
        {solicitacoes.length > 0 && (
          <button onClick={() => setAbaSolicitacoes(!abaSolicitacoes)} style={{ padding:'7px 14px', background:'#FAEEDA', color:'#854F0B', border:'1px solid #F5D9A8', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            ⚠️ {solicitacoes.length} solicitaç{solicitacoes.length!==1?'ões':'ão'} de senha
          </button>
        )}
      </div>

      {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}

      {/* SENHA PROVISÓRIA GERADA */}
      {senhaProvisoria && (
        <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:12, padding:20, marginBottom:20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div>
              <div style={{ fontSize:14, fontWeight:600, color:'#854d0e', marginBottom:8 }}>🔑 Senha provisória gerada — entregue ao servidor</div>
              <div style={{ fontSize:13, color:'#374151', marginBottom:4 }}>Servidor: <strong>{senhaProvisoria.nome}</strong></div>
              <div style={{ fontSize:13, color:'#374151', marginBottom:8 }}>E-mail: <strong>{senhaProvisoria.email}</strong></div>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ fontSize:24, fontFamily:'monospace', fontWeight:700, color:'#185FA5', background:'white', padding:'8px 16px', borderRadius:8, border:'1px solid #d1d5db', letterSpacing:2 }}>
                  {senhaProvisoria.senha}
                </div>
                <button onClick={() => navigator.clipboard.writeText(senhaProvisoria.senha)} style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>
                  📋 Copiar
                </button>
              </div>
              <div style={{ fontSize:11, color:'#854d0e', marginTop:8 }}>⚠️ O servidor será obrigado a trocar a senha no primeiro acesso.</div>
            </div>
            <button onClick={() => setSenhaProvisoria(null)} style={{ background:'none', border:'none', fontSize:18, cursor:'pointer', color:'#9ca3af' }}>✕</button>
          </div>
        </div>
      )}

      {/* SOLICITAÇÕES DE SENHA */}
      {abaSolicitacoes && solicitacoes.length > 0 && (
        <div style={{ background:'white', borderRadius:12, border:'1px solid #F5D9A8', padding:20, marginBottom:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:12, color:'#854F0B' }}>⚠️ Servidores aguardando senha provisória</div>
          {solicitacoes.map((u,i) => (
            <div key={u.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 0', borderBottom:i<solicitacoes.length-1?'1px solid #f3f4f6':'none' }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:13, fontWeight:500 }}>{u.nome}</div>
                <div style={{ fontSize:12, color:'#9ca3af' }}>{u.email} · Solicitado em {u.solicitou_senha_em ? new Date(u.solicitou_senha_em).toLocaleString('pt-BR') : '—'}</div>
              </div>
              <button onClick={() => gerarSenhaProvisoria(u)} disabled={load} style={{ padding:'6px 14px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:12, cursor:'pointer', fontWeight:500 }}>
                {load?'Gerando...':'Gerar senha provisória'}
              </button>
            </div>
          ))}
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'340px 1fr', gap:20 }}>
        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20, alignSelf:'start' }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>{editando ? 'Editar usuário' : 'Novo usuário'}</div>

          {[['nome','Nome completo *','Nome do servidor'],['email','E-mail *','servidor@prefeitura.gov.br'],['telefone','Telefone','(00) 00000-0000']].map(([k,l,p])=>(
            <div key={k} style={{ marginBottom:12 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>{l}</label>
              <input value={form[k]||''} onChange={e=>set(k,e.target.value)} placeholder={p}
                style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
          ))}

          <div style={{ marginBottom:12 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>{editando ? 'Nova senha (deixe em branco para manter)' : 'Senha *'}</label>
            <input type="password" value={form.senha||''} onChange={e=>set('senha',e.target.value)} placeholder="••••••••"
              style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
          </div>

          <div style={{ marginBottom:12 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:6, color:'#374151' }}>Perfil de acesso *</label>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              {Object.entries(PERFIS).map(([k,v]) => (
                <label key={k} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 10px', border:`1.5px solid ${form.perfil===k?v.cor:'#e5e7eb'}`, borderRadius:8, cursor:'pointer', background:form.perfil===k?v.bg:'white' }}>
                  <input type="radio" name="perfil" value={k} checked={form.perfil===k} onChange={()=>set('perfil',k)} style={{ flexShrink:0 }} />
                  <div>
                    <div style={{ fontSize:12, fontWeight:500, color:form.perfil===k?v.cor:'#374151' }}>{v.label}</div>
                    <div style={{ fontSize:11, color:'#9ca3af' }}>{v.desc}</div>
                  </div>
                </label>
              ))}
            </div>
          </div>

          <div style={{ marginBottom:12 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Perfil de acesso personalizado</label>
            <select value={form.perfil_id||''} onChange={e=>set('perfil_id',e.target.value)}
              style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
              <option value="">Sem perfil personalizado</option>
              {perfisLista.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
            </select>
            <div style={{ fontSize:11, color:'#9ca3af', marginTop:3 }}>Sobrescreve as permissões do tipo de perfil acima</div>
          </div>

          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Setor</label>
            <select value={form.setor_id||''} onChange={e=>set('setor_id',e.target.value)}
              style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
              <option value="">Sem setor definido</option>
              {secretarias.filter(s=>!s.pai_id).map(s=>(
                <optgroup key={s.id} label={s.nome}>
                  <option value={s.id}>{s.nome}</option>
                  {secretarias.filter(d=>d.pai_id===s.id).map(d=><option key={d.id} value={d.id}>  └ {d.nome}</option>)}
                </optgroup>
              ))}
            </select>
          </div>

          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:12, color:'#dc2626', marginBottom:10 }}>{erro}</div>}

          <div style={{ display:'flex', gap:8 }}>
            <button onClick={salvar} style={{ flex:1, padding:9, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
              {editando ? 'Salvar' : 'Criar usuário'}
            </button>
            {editando && <button onClick={() => { setEditando(null); setForm({ nome:'', email:'', senha:'', perfil:'atendente', setor_id:'', telefone:'' }) }}
              style={{ padding:'9px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>✕</button>}
          </div>
        </div>

        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
          <div style={{ padding:'14px 20px', borderBottom:'1px solid #f3f4f6', fontSize:14, fontWeight:500 }}>
            {lista.length} usuário{lista.length!==1?'s':''} cadastrado{lista.length!==1?'s':''}
          </div>
          {lista.length === 0
            ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af', fontSize:14 }}>Nenhum usuário cadastrado.</div>
            : lista.map((u,i) => {
              const perfil = PERFIS[u.perfil] || PERFIS.atendente
              return (
                <div key={u.id} style={{ padding:'14px 20px', borderBottom:i<lista.length-1?'1px solid #f3f4f6':'none', opacity:u.ativo?1:0.5 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    <div style={{ width:36, height:36, borderRadius:'50%', background:perfil.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:perfil.cor, flexShrink:0 }}>
                      {u.nome.substring(0,2).toUpperCase()}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ fontSize:13, fontWeight:500 }}>{u.nome}</div>
                        <span style={{ background:perfil.bg, color:perfil.cor, fontSize:10, padding:'1px 7px', borderRadius:99, fontWeight:500 }}>{perfil.label}</span>
                        {u.solicitou_senha && <span style={{ background:'#FAEEDA', color:'#854F0B', fontSize:10, padding:'1px 7px', borderRadius:99, fontWeight:500 }}>⚠️ Aguardando senha</span>}
                        {u.trocar_senha && <span style={{ background:'#f3f4f6', color:'#6b7280', fontSize:10, padding:'1px 7px', borderRadius:99 }}>Senha provisória</span>}
                        {!u.ativo && <span style={{ background:'#f3f4f6', color:'#9ca3af', fontSize:10, padding:'1px 7px', borderRadius:99 }}>Inativo</span>}
                      </div>
                      <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>
                        {u.email}
                        {u.setor_nome ? ` · ${u.setor_nome}` : ''}
                        {u.ultimo_acesso ? ` · Último acesso: ${new Date(u.ultimo_acesso).toLocaleDateString('pt-BR')}` : ' · Nunca acessou'}
                      </div>
                    </div>
                    <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                      {u.solicitou_senha && (
                        <button onClick={() => gerarSenhaProvisoria(u)} style={{ padding:'5px 10px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:11, cursor:'pointer', fontWeight:500 }}>
                          🔑 Gerar senha
                        </button>
                      )}
                      <button onClick={() => editar(u)} style={{ padding:'5px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:11, cursor:'pointer', background:'white' }}>Editar</button>
                      <button onClick={() => toggleAtivo(u)} style={{ padding:'5px 10px', border:`1px solid ${u.ativo?'#fecaca':'#bbf7d0'}`, borderRadius:6, fontSize:11, cursor:'pointer', background:'white', color:u.ativo?'#dc2626':'#15803d' }}>
                        {u.ativo ? 'Desativar' : 'Reativar'}
                      </button>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </Layout>
  )
}
